<template>
  <div>
    <div class="head">
      <h3>【世道中医门诊部】{{customerInfo?.name}}的病历</h3>
      <h4>姓名 {{customerInfo?.name}} 性别 {{customerInfo?.gender?customerInfo.gender:"--"}} 年龄 {{customerInfo?.age?customerInfo?.age:"--"}} 身高(CM) {{customerInfo?.height?customerInfo.height:"---"}} 体重(公斤) {{customerInfo?.weight?customerInfo?.weight:"---"}}
        <!-- 职业 {{customerInfo?.height?customerInfo.height:"---"}} -->
        <a-button @click="visible=true" size="small">修改</a-button>
      </h4>
      <h4>就诊日期: 2025-04-23 首诊日期: 2024-07-02 上次看诊日期: 2024-07-02 责任医师: {{}}</h4>
    </div>

  </div>
  <editCustomer v-model="visible" :customerInfo="customerInfo" @reSearch="getRecordDetail" />
</template>

<style scoped>
.head {
  text-align: center;
  position: fixed;
  width: 100%;
  z-index: 9;
  background-color: #fff;
  border-bottom: 1px solid #ccc;
}
</style>


<script>
import {  } from "/src/api/medicalRecord.js";
import editCustomer from "/src/components/medicalRecord/editCustomer.vue";
export default {
  components: {
    editCustomer,
  },
  name: "病历",
  data() {
    return {
      visible: false,
    };
  },
  props: {
    customerInfo: {
      type: Object,
      default: {}
    }
  },
  created() { },
  mounted() {
    this.init()
  },
  activated() {

  },
  methods: {
    async init() {
      console.log("Header:customerInfo", this.customerInfo);

    },

  }
};
</script>


